import React from "react";
import "./index.scss";
import { Box, Button, Illustration, Text, UnorderedList } from "@mbank-design/design-system/components";
import { IllustrationSize } from "@mbank-design/design-system/enums";
import * as Illustrations from "@mbank-design/design-system/illustrations";
import CustomIllustration from "../../../assets/images/promo_ilustration.png";
import "./index.scss";
const PromoBannerMB = ({ literals, urlToContactSection, handleContactModal }) => {
  if (
    !literals.promo_label_new_car_title ||
    !literals.promo_label_new_car_subtitle ||
    !literals.promo_label_new_car_illustration ||
    !literals.promo_label_afterlease_car_title ||
    !literals.promo_label_afterlease_car_subtitle ||
    !literals.promo_label_afterlease_car_illustration
  ) {
    return;
  }
  const handleButtonClick = () => {
    setLocalStorageContactPreference();
    handleContactModal(urlToContactSection);
  };

  const setLocalStorageContactPreference = () => {
    localStorage.setItem("onlyOffer", true);
    // LinkedIn Insight Tag
    // setVehicleOfferButtonInsightTag();
  };

  const convertColorLiteral = (literal) => {
    literal = literal.replaceAll("[SPAN]", "<span>");
    literal = literal.replaceAll("[/SPAN]", "</span>");

    literal = literal.replaceAll("[SPAN", "<span");
    literal = literal.replaceAll('"]', '">');
    return literal;
  };
  return (
    <div className="promo-banner-mb">
      <div className="promo-banner-mb__content">
        <div className="promo-banner-mb__left">
          <div className="promo-banner-mb__title">
          <Box background={"#ae0000"} padding={8} borderRadius={"small"} width={"fit-content"}>
            <Text as={"p"} color={"white30"}>
              promocja
            </Text>
          </Box>
            {(
              <Text
                as={"h1"}
                marginTop={6}
                marginBottom={6}
                fontSize={[32,36]}
              >
                To auto może być tańsze o <span style={{ color: "#ae0000" }}>2000 zł!</span>
              </Text>
            )}
          </div>
          <div className="promo-banner-mb__subtitle">
          Jesteś klientem mBanku? Skorzystaj z promocji „Taniej z mAuto” i odbierz dodatkowy rabat na to auto.
          </div>
          {/* <div className="promo-banner-for-all__button">
            <Button buttonType="primary" onClick={handleButtonClick}>
              zapytaj o ofertę
            </Button>
          </div> */}
      <div>
        <Text as={"body"} marginTop={12} fontSize={12}>
        Szczegóły promocji w  <a href="https://mleasing.pl/pdf/promocje/Taniej-z-mAuto-edycja-4-01.04.2026.pdf" target="_blank" rel="noreferrer">regulaminie.</a>
        </Text>
      </div>
          </div>
        <div className="promo-banner-mb__right">
          <img src={CustomIllustration} alt="Promo Banner" width={256}  />
        </div>
      </div>
    </div>
  );
};

export default PromoBannerMB;
